"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCardBody = exports.StyledCardHero = exports.StyledCardContainer = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const Card_types_1 = require("./Card.types");
exports.StyledCardContainer = styled_components_1.default.div `
  display: flex;
  align-items: stretch;
  background-color: ${({ theme }) => theme.colors.colours.default.white.value};
  filter: brightness(100%);
  -webkit-filter: brightness(100%);

  ${({ orientation }) => {
    if (orientation === Card_types_1.CardOrientation.Landscape) {
        return (0, styled_components_1.css) `
        width: 100%;
        height: 100%;
        flex-direction: row;
      `;
    }
    return (0, styled_components_1.css) `
      height: 100%;
      flex-direction: column;
    `;
}};

  ${({ theme, hover, cardStyle }) => {
    if (!hover)
        return null;
    if (cardStyle === Card_types_1.CardStyle.Shadowed) {
        return (0, styled_components_1.css) `
        cursor: pointer;
        &:hover {
          box-shadow: ${theme.shadows.hovered.value};
        }
        &:active {
          box-shadow: ${theme.shadows.pressed.value};
        }
      `;
    }
    return (0, styled_components_1.css) `
      cursor: pointer;
      &:hover {
        filter: brightness(95%);
        -webkit-filter: brightness(95%);
      }
      &:active {
        filter: brightness(90%);
        -webkit-filter: brightness(90%);
      }
    `;
}}

  ${({ theme, cardStyle }) => theme &&
    cardStyle === Card_types_1.CardStyle.Outlined &&
    (0, styled_components_1.css) `
      border: ${theme.borders['border-1px--solid']['border-width'].value}
        ${theme.borders['border-1px--solid']['border-style'].value} ${theme.colors.colours.support['40'].value};
    `}
  ${({ theme, cardStyle }) => cardStyle === Card_types_1.CardStyle.Shadowed &&
    (0, styled_components_1.css) `
      box-shadow: ${theme.shadows.resting.value};
    `}

  ${({ theme, selected }) => selected &&
    (0, styled_components_1.css) `
      border: ${theme.borders['border-3px--solid']['border-width'].value}
        ${theme.borders['border-3px--solid']['border-style'].value} ${theme.colors.theme.themePrimary.value};
    `};

  ${({ theme, disabled }) => disabled &&
    (0, styled_components_1.css) `
      border-color: ${theme.colors.colours.system['disable-light-theme'].value};
    `}
`;
exports.StyledCardHero = styled_components_1.default.div `
  display: flex;
  align-items: stretch;
  position: relative;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 'initial')};

  ${({ orientation }) => {
    if (orientation === Card_types_1.CardOrientation.Landscape) {
        return (0, styled_components_1.css) `
        width: 33.3%;
        > * {
          height: 100%;
        }
      `;
    }
    return (0, styled_components_1.css) `
      > * {
        width: 100%;
      }
    `;
}};
`;
exports.StyledCardBody = styled_components_1.default.div `
  padding: ${({ theme }) => theme.sizes.xs.value};
  @media screen and (max-width: ${({ theme }) => { var _a; return (_a = theme.layout.small['device-max-width']) === null || _a === void 0 ? void 0 : _a.value; }}) {
    padding: ${({ theme }) => theme.sizes['2xs'].value};
  }
  ${({ orientation }) => {
    if (orientation === Card_types_1.CardOrientation.Landscape) {
        return (0, styled_components_1.css) `
        width: 66.7%;
      `;
    }
    return (0, styled_components_1.css) `
      width: inherit;
    `;
}};
`;
//# sourceMappingURL=Card.styled.js.map